var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.645,
    height: 16.645,
    viewBox: "0 0 16.645 16.645",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.153,4.545A2.158,2.158,0,0,1,12.1,1.493L10.608,0,0,10.608,1.493,12.1a2.158,2.158,0,0,1,3.053,3.053l1.493,1.493L16.645,6.038Zm-6.846,1.4-.692-.692.69-.69L9,5.258ZM9.692,7.332,9,6.64l.69-.69.692.692Zm1.385,1.385-.692-.692.69-.69.692.692Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.77f5d335.svg";
export { ForwardRef as ReactComponent };